import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 25C8CF6C-01BB-4E4A-A946-47A58A854957
 * name invoice-multiple
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-multiple.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceMultipleIcon = createSvgIcon(<><path d="M17 2H2V17H4V4H17V2M21 22L18.5 20.32L16 22L13.5 20.32L11 22L8.5 20.32L6 22V6H21V22Z" /></>, 'InvoiceMultipleIcon');
export default InvoiceMultipleIcon